import api from "lib/axios";
import type { ApiEnvelope, PaginatedResult } from "./apiTypes";
import { unwrapList } from "./apiTypes";

export type AdminJoinRequest = {
  id: number;
  request_type: "course";
  course_id: number;
  student_id: number;
  status: "pending" | "approved" | "rejected" | "cancelled";
  message?: string | null;
  payment_method?: "vodafone_cash" | "instapay" | null;
  payment_submitted_at?: string | null;
  payment_proof_url?: string | null;
  rejection_reason?: string | null;
  reviewed_at?: string | null;
  created_at?: string | null;
  student?: {
    id: number;
    name?: string | null;
    phone?: string | null;
    profile?: { stage?: string | null; grade?: string | null } | null;
  } | null;
  course?: {
    id: number;
    title?: string | null;
    price?: number | null;
    currency?: string | null;
    pricing_type?: string | null;
    subject?: { id: number; name?: string | null } | null;
  } | null;
  instructor?: { id: number; name?: string | null } | null;
};

export type AdminJoinRequestsQuery = {
  page?: number;
  limit?: number;
  term?: string;
  status?: AdminJoinRequest["status"] | "";
  course_id?: number;
};

export type ApproveAdminJoinRequestBody = {
  start_date: string;
  end_date: string;
  price_paid?: number | null;
};

export const adminJoinRequestsService = {
  async list(params: AdminJoinRequestsQuery = {}) {
    const response = await api.get<ApiEnvelope<PaginatedResult<AdminJoinRequest>>>(
      "/mcp/course-join-requests",
      { params, meta: { toastSuccess: false } }
    );
    return unwrapList(response.data);
  },

  async approve(id: number, body: ApproveAdminJoinRequestBody) {
    return api.post<ApiEnvelope<AdminJoinRequest>>(
      `/mcp/course-join-requests/${id}/approve`,
      body,
      { meta: { toastError: false } }
    );
  },

  async reject(id: number, rejection_reason?: string) {
    return api.post<ApiEnvelope<AdminJoinRequest>>(
      `/mcp/course-join-requests/${id}/reject`,
      { rejection_reason: rejection_reason || null },
      { meta: { toastError: false } }
    );
  },
};
